module.exports = __webpack_public_path__ + "img/UserInjuries.34bc835a.svg";